import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import AgGridTable from './ag-grid-table';
import { closeRightPane } from '../common/actions/right-pane-action-creators';

export class AgGridTableContainer extends Component{
    render(){
        const {
            closeRightPane,
            columnDefs,
            context,
            customGridOptions,
            dataAutomationId,
            exportCSVFileName,
            exportToCSVSuccess,
            exportToCSVFailure,
            isExportingGridToCSV,
            isLoading,
            rowClickHandler,
            rowData,
            scrollToTop,
            tableType,
            widgetId,
        } = this.props;

        return (
            <AgGridTable
                columnDefs={columnDefs}
                context={context}
                dataAutomationId={dataAutomationId}
                exportCSVFileName={exportCSVFileName}
                exportToCSVSuccess={exportToCSVSuccess}
                exportToCSVFailure={exportToCSVFailure}
                customGridOptions={customGridOptions}
                isExportingGridToCSV={isExportingGridToCSV}
                isLoading={isLoading}
                onFilterChanged={closeRightPane}
                onSortChanged={closeRightPane}
                rowClickHandler={rowClickHandler}
                rowData={rowData}
                scrollToTop={scrollToTop}
                tableType={tableType}
                widgetId={widgetId}
            />
        );
    }
};

AgGridTableContainer.propTypes = {
    closeRightPane: PropTypes.func.isRequired,
    columnDefs: PropTypes.array.isRequired,
    context: PropTypes.object,
    customGridOptions: PropTypes.object,
    dataAutomationId: PropTypes.string.isRequired,
    exportCSVFileName: PropTypes.string,
    exportToCSVFailure: PropTypes.func,
    exportToCSVSuccess: PropTypes.func,
    isExportingGridToCSV: PropTypes.bool,
    isLoading: PropTypes.bool,
    rowClickHandler: PropTypes.func,
    rowData: PropTypes.array.isRequired,
    scrollToTop: PropTypes.bool,
    tableType: PropTypes.string,
    widgetId: PropTypes.oneOfType( [
        PropTypes.string,
        PropTypes.number,
    ] ),
};

export default connect( null, { closeRightPane } )( AgGridTableContainer );
